import common from '@page/common/js/common';
import globalLayout from '@global/components/Home/globalLayout'; //公版模組
import freelayout from '@global/components/Home/freelayout';
require('@global/vendors/slick');

globalLayout({
  banner: {
    isopen: true,
    opts: {
      dots: true,
      arrows: false,
      speed: 800,
      autoplay: true,
      autoplaySpeed: 5000,
    },
    squareOpts: {
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: false,
      arrows: true,
      speed: 800,
      responsive: [
        {
          breakpoint: 415,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
            dots: false,
          },
        },
      ],
    },
    fullbanner: {
      play: 5000,
    },
  },
  popupOpen: true,
  popupShowOnce: true,
});

setTimeout(function () {
  $('#page-home').css('opacity', '1');
}, 100);

$(document).ready(function () {
  const $header = $('#page-home .header');
  const headerHight = $header.height();

  if ($header.length < 1) return;

  function windowSize() {
    if ($(window).width() < 1200) {
      $('#page-home .header').addClass('mobile-header');
      return true;
    }
  }

  $(window).resize(function () {
    windowSize();
  });

  let isMobile = windowSize();

  $(window).scroll(function () {
    if (!isMobile) {
      $(window).scrollTop() > headerHight
        ? $header.addClass('active')
        : $header.removeClass('active');
    }
    if (new Date().getTime() < new Date(2023, 11, 31, 23, 59, 59).getTime()) {
      if ($('body').hasClass('sq-event')) {
        $('.header').hasClass('active')
          ? $('.header .logo-image img').attr(
              'src',
              'https://static.tpx.tw/sff/squarebear/static/img/eventLogo-green.svg',
            )
          : $('.header .logo-image img').attr(
              'src',
              'https://static.tpx.tw/sff/squarebear/static/img/eventLogo-pink.svg',
            );
      }
    }
  });
});

freelayout.initSlick();
freelayout.transitionEffects();
